'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import ErrorPage from "@/_pages/error-page/error-page";
import sendAppError from "@/libs/logger/requests/send-app-error";
export default function Error(t0) {
  const $ = _c(10);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] !== error.cause || $[1] !== error.digest || $[2] !== error.message || $[3] !== error.name || $[4] !== error.stack) {
    t1 = () => {
      sendAppError({
        cause: error.cause,
        digest: error.digest,
        message: error.message,
        name: error.name,
        stack: error.stack
      }).catch(_temp);
      console.error(`[APP ERROR - Date ISO: ${new Date().toISOString()}]:`, {
        cause: error.cause,
        digest: error.digest,
        message: error.message,
        name: error.name,
        stack: error.stack
      });
    };
    $[0] = error.cause;
    $[1] = error.digest;
    $[2] = error.message;
    $[3] = error.name;
    $[4] = error.stack;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== error) {
    t2 = [error];
    $[6] = error;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  if ($[8] !== reset) {
    t3 = <ErrorPage reset={reset} />;
    $[8] = reset;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp() {
  console.error(`[API ERROR - Date ISO: ${new Date().toISOString()}]: Error to send error data to server`);
}